import { render, staticRenderFns } from "./LocaleBase.vue?vue&type=template&id=213a9fc7&"
import script from "./LocaleBase.vue?vue&type=script&lang=js&"
export * from "./LocaleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports